<template>
  <div style="display: inline-block">
    <Dropdown :transfer="true" trigger="contextMenu" placement="bottom-end">
      <div>
        {{r.title}}
      </div>
      <DropdownMenu slot="list">
        <DropdownItem @click.native="refesh">
          <Icon type="md-refresh" :size="14" />&nbsp;刷新当页
        </DropdownItem>
        <DropdownItem divided @click.native="refeshAll">
          <Icon type="md-refresh" :size="14" />&nbsp;刷新所有
        </DropdownItem>
        <DropdownItem @click.native="closeAll">
          <Icon type="md-close" :size="14" />&nbsp;关闭其他所有
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    r: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['allSelectedKeys']),
  },
  methods: {
    refesh() {
      const list = this.allSelectedKeys.map((l) => {
        if (l.key === this.r.key) {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.allSelectedKeys.map((l) => {
          if (l.key === this.r.key) {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    refeshAll() {
      const list = this.allSelectedKeys.map((l) => {
        l.refesh = true
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.allSelectedKeys.map((l) => {
          l.refesh = false
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    closeAll() {
      const list = this.allSelectedKeys.filter(
        (l, i) => l.key === this.r.key
      )
      this.$store.commit("setActiveKey", this.r.key)
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
    },
  }
}
</script>